// removed by extract-text-webpack-plugin
module.exports = {"hasExpiredOverlay":"_1AEoHxFVH96nsLV7-RpLZK","textContainer":"_3HHtowM4vQpRLEP1BCm7ab","title":"_21JlM2OulbU5zaDaxLFkXh","text":"_1zFuXpTcv1Bz-VtUcuc0Jw"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/openBetOverlay.css
// module id = 720
// module chunks = 0